import {emptySplitApi} from "./api";
import {logout} from "../redux/slices/authenticationSlice";

export const authenticationApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (credentials) => ({
                url: 'auth/login',
                method: 'POST',
                body: credentials
            })
        }),
        logout: builder.mutation( {
            query: () => ({
                url: 'auth/logout',
                method: 'GET'
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                } catch { }
                dispatch(logout())
                dispatch(emptySplitApi.util.resetApiState());
            }
        }),
        register: builder.mutation({
            query: (data) => ({
                url: 'auth/register',
                method: 'POST',
                body: data
            })
        }),
        forgotPassword: builder.mutation({
            query: (data) => ({
                url: 'auth/forgot-password',
                method: 'POST',
                body: data
            })
        }),
        changePassword: builder.mutation({
            query: (data) => ({
                url: 'auth/change-password',
                method: 'POST',
                body: data
            })
        }),
        userProfile: builder.query( {
            query: () => ({
                url: 'auth/user-profile',
                method: 'GET'
            }),
            providesTags: ['UserProfile']
        }),
        recreateRefreshToken: builder.mutation( {
            query: () => ({
                url: 'auth/recreate-refresh-token',
                method: 'GET'
            }),
            invalidatesTags: ['CompanyUser', 'KPITarget', 'KPIValue', 'KPITask', 'PriorityPlanner',
                'PriorityOrder', 'PriorityTask', 'SAMTask', 'SAMMeeting', 'Department', 'Location', 'Survey']
        })
    })
});

export const {
    useLoginMutation,
    useLogoutMutation,
    useForgotPasswordMutation,
    useChangePasswordMutation,
    useRegisterMutation,
    useUserProfileQuery,
    useLazyUserProfileQuery,
    useRecreateRefreshTokenMutation
} = authenticationApi;
